import React from "react";
import {MessageCircle, Instagram, Phone} from "lucide-react";

const FixedBar = ({isScrolled}) => {
    return (
        <div className="w-full h-[80px] flex items-center justify-around">
            <div className="flex space-x-7">
                <MessageCircle
                    className={`w-5 h-5 ${isScrolled ? 'text-black' : 'text-white'} hover:opacity-80 cursor-pointer`}
                />
                <Instagram
                    className={`w-5 h-5 ${isScrolled ? 'text-black' : 'text-white'} hover:opacity-80 cursor-pointer`}
                />
                <Phone
                    className={`w-5 h-5 ${isScrolled ? 'text-black' : 'text-white'} hover:opacity-80 cursor-pointer`}
                />
            </div>
            <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://wa.link/txunpz"
                className={`${isScrolled ? 'bg-[#292929] text-white' : 'bg-white text-black'} px-6 py-2 rounded-md hover:bg-gray-400 transition-colors`}
            >
                Contact Us
            </a>
        </div>
    )
        ;
};

export default FixedBar;